import { useMemo } from 'react'
import { PrimitiveAtom } from 'jotai'
import { focusAtom } from 'jotai-optics'
import { scopeToString } from '../../scope'
import { Scope } from '../../types'
import { useViewStateActiveAtom, useViewStateDefaultAtom } from './base-atom'

export const useViewStatePropAtom = <T>(
  key: string,
  scope: Scope,
  defaultValue: T,
) => {
  const viewStateAtom = useViewStateActiveAtom(scope)

  const atom = useMemo(() => {
    const propAtom = focusAtom(viewStateAtom, (optic) => {
      const keys = key.split('.')
      const pathKeys = keys.slice(0, -1)
      const finalKey = keys.slice(-1)

      // Find the data object
      const dataOptic = optic.prop('data' as never).valueOr({})

      // Walk down the path, creating it if it does not exist
      const pathOptic =
        pathKeys.length > 0
          ? pathKeys.reduce((prev, cur) => {
              return prev.prop(cur as never).valueOr({})
            }, dataOptic)
          : dataOptic

      // Find the final value
      return pathOptic.prop(finalKey as never).valueOr(defaultValue)
    })
    propAtom.debugLabel = `viewstate.scope(${scopeToString(
      scope,
    )}).prop(${key})`
    return propAtom
  }, [viewStateAtom, scope, key])
  return atom as PrimitiveAtom<T>
}

export const useViewStateOriginalPropAtom = <T>(
  key: string,
  scope: Scope,
  defaultValue: T,
) => {
  const viewStateAtom = useViewStateDefaultAtom(scope)
  const atom = useMemo(() => {
    const propAtom = focusAtom(viewStateAtom, (optic) => {
      const keys = key.split('.')
      const pathKeys = keys.slice(0, -1)
      const finalKey = keys.slice(-1)

      // Find the data object
      const dataOptic = optic.prop('data' as never).valueOr({})

      // Walk down the path, creating it if it does not exist
      const pathOptic =
        pathKeys.length > 0
          ? pathKeys.reduce((prev, cur) => {
              return prev.prop(cur as never).valueOr({})
            }, dataOptic)
          : dataOptic

      // Find the final value
      return pathOptic.prop(finalKey as never).valueOr(defaultValue)
    })
    propAtom.debugLabel = `viewstate.scope(${scopeToString(
      scope,
    )}).original.prop(${key})`
    return propAtom
  }, [viewStateAtom, scope, key])
  return atom as PrimitiveAtom<T>
}
